import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { translateISODateToString } from '@alfa-bank/site-invest-common/helpers/date/translate-iso-date-to-string';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Link } from '@alfa-bank/site-link';
import { ImgV2 as Img } from '@alfa-bank/site-img-v2';
import { createPageUrl } from '@alfa-bank/site-invest-mediaportal-common/helpers';
import { FontStyrene } from '@alfa-bank/site-font-styrene';
import { AssetsCarouselDesktop as AssetsCarousel } from '@alfa-bank/site-invest-mediaportal-common/components/assets-carousel-desktop';

import type { IArticleProps } from '../../model';
import { sendClickCardAnalytics } from '../../../../helpers/analytics';
import { getFileBanner } from '../../../../helpers/get-file-banner';

import styles from './styles.css';

export const ArticleListDesktop: FC<IArticleProps> = ({
    analytics,
    articles,
    baseUrlToArticle,
    baseUrlToAsset,
    dataTestId,
}) => {
    return (
        <div className={cn(styles.external, styles.wrapper)}>
            {articles.map(item => {
                const image = getFileBanner(item);

                return (
                    <Block
                        key={item.path}
                        className={cn(styles.external, styles.block)}
                        notPadded
                        styler={{ borderRadius: 32, padding: 24 }}
                    >
                        <Link
                            className={cn(styles.external, styles.link)}
                            dataTestId={dataTestId}
                            href={createPageUrl(baseUrlToArticle, item.path)}
                            noUnderline
                            onClick={() => sendClickCardAnalytics(item, analytics)}
                        >
                            <Text
                                kind="secondary"
                                styler={{ margin: 0 }}
                                view="action-primary-medium"
                            >
                                {item.category.description}
                                &nbsp;&bull;&nbsp;
                                {translateISODateToString(item.publicationDate, {
                                    convertToMoscowDate: true,
                                })}
                            </Text>
                            <Block notPadded styler={{ marginTop: 12 }}>
                                <FontStyrene>
                                    <Text styler={{ margin: 0 }} view="small">
                                        {item.title}
                                    </Text>
                                </FontStyrene>
                                <Text styler={{ margin: 0, marginTop: 8 }} view="primary-medium">
                                    {item.description}
                                </Text>
                            </Block>
                            {image && (
                                <Img
                                    alt={`Лого ${image.name}`}
                                    className={cn(styles.external, styles.image)}
                                    height={300}
                                    src={image.link}
                                    styler={{ marginTop: 12 }}
                                    width={704}
                                />
                            )}
                        </Link>
                        {!!item.assets?.length && (
                            <AssetsCarousel
                                analytics={analytics}
                                assetCardTheme="grey"
                                assets={item.assets}
                                baseUrlToAsset={baseUrlToAsset}
                                className={cn(styles.external, styles.assetsLinksBlock)}
                            />
                        )}
                    </Block>
                );
            })}
        </div>
    );
};
